import ApiImage from 'models/data/api/ApiImage'
import ContentfulToApiImage from 'models/data/mappings/ContentfulToApiImage'
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { get } from 'lodash'
import ContentfulImage from './ContentfulImage';

class ContentfulRichText {
	static options = {
		renderNode: {
			[BLOCKS.EMBEDDED_ASSET]: (node: any) => {
				const contentfulImage = node.data.target;
				const apiImage = ContentfulToApiImage.map(contentfulImage);
				return `<img src="${ApiImage.url(apiImage)}" alt="${ApiImage.description(apiImage)}" />
                    <p class="image-caption">
                        ${ApiImage.description(apiImage)}
                    </p>
                `;
			},

			[INLINES.HYPERLINK]: (node: any, next: any) => {
				if((node.data.uri).includes("youtube.com/embed")) {
					return `<iframe src="${node.data.uri}" width="100%" height="337.5px"></iframe>`
				} else if((node.data.uri).includes("instagram.com/p/") && (node.data.uri).includes("embed")) {
					return `
						<p align="center">
							<iframe
								src="${node.data.uri}"
								frameborder="0"
								allowfullscreen
								scrolling="no"
								allowtransparency
								maxWidth="350"
								height="400"
							></iframe>
						</p>
					`
				} else if((node.data.uri).includes("https://open.spotify.com/embed/")) {
					return `
						<p align="center">
							<iframe src="${node.data.uri}" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
						</p>
					`
				} else if ((node.data.uri).includes("amuselabs.com")) {
					return `
						<iframe id="iframe-xword" height="770px" width="100%" allowtransparency="false" allowfullscreen="true" frameborder="0" scrolling="yes" style="border:none;max-width:100%;width:100% !important;position: static;display: block !important;margin: 0 !important;" name="crossword" src="${node.data.uri}"></iframe>
					`;
				} else {
					return `<a href="${node.data.uri}" target="_blank">${next(node.content)}</a>`;
				}
			}
		}
	};

	static toHtml = contentfulRichText =>
		documentToHtmlString(contentfulRichText, ContentfulRichText.options);

	static images = contentfulRichText => {
		return get(contentfulRichText, "content", [])
			.filter(node => get(node, "nodeType", "") === "embedded-asset-block")
			.map(node => get(node, "data.target", ContentfulImage.default));
	};
}

export default ContentfulRichText
